import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useApiAuth } from '@/hooks/useApiAuth';
import { ApiAuthContext } from '@/hooks/ApiAuthContext';

export default function AppShell() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Configure API client with MSAL authentication
  const { isReady } = useApiAuth();

  return (
    <ApiAuthContext.Provider value={isReady}>
      <div className="flex h-screen overflow-hidden bg-neutral-50">
        {/* Sidebar */}
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />

        {/* Main content area */}
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* Header */}
          <Header />

          {/* Page content */}
          <main className="flex-1 overflow-y-auto">
            <div className="container mx-auto p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </ApiAuthContext.Provider>
  );
}
